import { RelationToUser } from '../types/driver';

// Mock data to move user to onboarding for E2E test.
export const mockDataServer = {
  __typename: 'User',
  id: 'testID',
  name: 'Jerry Maguire',
  phone: '0000000001',
  phoneVerified: false,
  email: null,
  mlCoverageEnabled: false,
  isSigned: true,
  signupParams:
    '{"validated":false,"step":0,"autoSwitchEnabled":true,"homeInsuranceEnabled":false,"shopForEnabled":true,"changeObOrderEnabled":false,"telematicsSignupParam":false,"askAgeLicensedEnabled":false,"askPhoneBeforeName":false,"askVehicleOwnership":false,"appSignup":false,"askReferral":true,"showCancelButtonEditModal":false,"newIntroPagesEnabled":false,"reorderSignUpEnabled":true,"askViolationSignup":false,"shopFor":{"home":false,"renters":false,"umbrella":false,"condo":false},"shopFrequency":"ai","isAutoInsured":true,"autoInsuredLength":"OneToThreeYears","claims":false,"violations":false,"advertiserCookies":{},"userAgent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.114 Safari/537.36","lastStep":"verify","furthestStep":"verify"}',
  isHomeowner: null,
  telematics: true,
  dateOfBirthMasked: null,
  age: null,
  referralSource: null,
  address: null,
  isOnboardingLite: false,
  isBeyondDrivingAge: true,
  isFromMAL: false,
  driverID: 'RHJpdmVyOjE3OTk=',
  cars: { __typename: 'UserCarConnection', edges: [] },
  drivers: {
    edges: [
      {
        node: {
          id: 'RHJpdmVyOjE3OTc=',
          isArchived: false,
          name: 'Jerry Maguire',
          gender: null,
          dateOfBirthMasked: null,
          age: null,
          driverLicenseNumberMasked: null,
          driverLicenseState: null,
          maritalStatus: null,
          relationToUser: RelationToUser.Insured,
          occupation: null,
          industry: null,
          education: null,
          driverTraining: null,
          goodStudent: null,
          __typename: 'Driver',
        },
        __typename: 'DriverEdge',
      },
    ],
    __typename: 'DriverConnection',
  },
};
